import 'babel-polyfill';
import {BodyComponent} from "../components/body/body-component";
import {DropzoneComponent} from "../components/dropzone/dropzone-component";
import {Form} from "../components/form/form";
import {FormField} from "../components/form-field/form-field";
import {FormFieldChecks} from "../components/form-field-checks/form-field-checks";
import {FormFieldDate} from "../components/form-field-date/form-field-date";
import {FormFieldInput} from "../components/form-field-input/form-field-input";
import {FormFieldRadio} from "../components/form-field-radio/form-field-radio";
import {FormFieldSelect} from "../components/form-field-select/form-field-select";
import {FormFieldTextarea} from "../components/form-field-textarea/form-field-textarea";
import {FormFieldModelSelector} from "../components/form-field-model-selector/form-field-model-selector";
import {GvfUiService} from "../../gvf/js/gvf-ui-service";
import {FormFieldSelectImage} from "../components/form-field-select-image/form-field-select-image";
import {ModHeader} from "../components/mod-header/mod-header";
import {ModFooter} from "../components/mod-footer/mod-footer";
import {FormFieldHtml} from "../components/form-field-html/form-field-html";
import {FormFieldFiles} from "../components/form-field-files/form-field-files";
import {FormFieldRating} from "../components/form-field-rating/form-field-rating";
import {FormFieldRepeater} from "../components/form-field-repeater/form-field-repeater";
import {FormFieldSignature} from "../../cp/components/form-field-signature/form-field-signature";
import {FormFieldTelephonePrefix} from "../components/form-field-telephone-prefix/form-field-telephone-prefix";
import {LandingReveal} from "../components/landing/landing-reveal";

GvfUiService.registerComponent(".js-body",BodyComponent);
GvfUiService.registerComponent(".js-form",Form);
GvfUiService.registerComponent(".js-form-field",FormField);
GvfUiService.registerComponent(".js-form-field-checks",FormFieldChecks);
GvfUiService.registerComponent(".js-form-field-date",FormFieldDate);
GvfUiService.registerComponent(".js-form-field-input",FormFieldInput);
GvfUiService.registerComponent(".js-form-field-radio",FormFieldRadio);
GvfUiService.registerComponent(".js-form-field-select",FormFieldSelect);
GvfUiService.registerComponent(".js-form-field-select-image",FormFieldSelectImage);
GvfUiService.registerComponent(".js-form-field-textarea",FormFieldTextarea);
GvfUiService.registerComponent(".js-form-field-html",FormFieldHtml);
GvfUiService.registerComponent(".js-form-field-files",FormFieldFiles);
GvfUiService.registerComponent(".js-form-field-rating",FormFieldRating);
GvfUiService.registerComponent(".js-form-field-model-selector",FormFieldModelSelector);
GvfUiService.registerComponent(".js-form-field-repeater",FormFieldRepeater);
GvfUiService.registerComponent(".js-form-field-signature",FormFieldSignature);
GvfUiService.registerComponent(".js-form-field-telephone-prefix",FormFieldTelephonePrefix);
GvfUiService.registerComponent(".js-dropzone",DropzoneComponent);
GvfUiService.registerComponent(".js-mod-header",ModHeader);
GvfUiService.registerComponent(".js-mod-footer",ModFooter);
GvfUiService.registerComponent(".js-landing-reveal",LandingReveal);

GvfUiService.registerDelayedComponent(".js-mod-gvml",()=>import("../components/mod-gvml/mod-gvml"));
GvfUiService.registerDelayedComponent(".js-mod-dynamic-form",()=>import("../components/mod-dynamic-form/mod-dynamic-form"));
GvfUiService.registerDelayedComponent(".js-mod-custom-form",()=>import("../components/mod-custom-form/mod-custom-form"));
GvfUiService.registerDelayedComponent(".js-dynamic-form-embed",()=>import("../components/dynamic-form-embed/dynamic-form-embed"));
GvfUiService.registerDelayedComponent(".js-mod-landing-cta",()=>import("../components/mod-landing-cta/mod-landing-cta"));
GvfUiService.registerDelayedComponent(".js-mod-msg-wa-chat-link",()=>import("../components/mod-msg-wa-chat-link/mod-msg-wa-chat-link"));
GvfUiService.registerDelayedComponent(".js-stock-remote-scan",()=>import("../components/stock-remote-scan/stock-remote-scan"));
GvfUiService.registerDelayedComponent(".js-pos-remote-scan",()=>import("../components/pos-remote-scan/pos-remote-scan"));
GvfUiService.registerDelayedComponent(".js-stock-remote-photo",()=>import("../components/stock-remote-photo/stock-remote-photo"));

GvfUiService.registerDelayedComponent(".js-mod-qrclient",()=>import("../components/mod-qrclient/mod-qrclient.js"));
